import React, { useCallback } from 'react'
import { SpendChartPoint } from 'src/queries/reporting/reporting.models'

import {
  firstPresentMetadataValue,
  ReportingPanelQueryParams,
} from './reportingPanelUtils'
import SpendStackedBarPanel from './SpendStackedBarPanel'

const TotalCompanySpendPanel: React.FC<ReportingPanelQueryParams> = (props) => {
  const seriesLabelForPoint = useCallback((point: SpendChartPoint) => {
    const cardType =
      firstPresentMetadataValue(point, ['cardType', 'seriesLabel']) ??
      point.seriesLabel ??
      point.label

    return cardType.toLowerCase().includes('physical') ? 'Physical' : 'Virtual'
  }, [])

  return (
    <SpendStackedBarPanel
      {...props}
      chartId="total_company_spend"
      title="Total company spend"
      description="Company spend over time by card type."
      seriesLabelForPoint={seriesLabelForPoint}
    />
  )
}

export default TotalCompanySpendPanel
